import { useState, useEffect } from 'react';

var getPlatform = function () {
    var _a;
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    var userAgentDataPlatform = (_a = navigator.userAgentData) === null || _a === void 0 ? void 0 : _a.platform;
    if (userAgentDataPlatform === 'Android' || navigator.userAgent.includes('Android')) {
        return 'android';
    }
    if (navigator.platform === 'iPhone' || navigator.userAgent.includes('iPhone')) {
        return 'ios';
    }
    if (userAgentDataPlatform === 'Windows' ||
        navigator.platform.startsWith('Win') ||
        navigator.userAgent.includes('Windows')) {
        return 'windows';
    }
    if (userAgentDataPlatform === 'macOS' ||
        navigator.platform.startsWith('Mac') ||
        navigator.userAgent.includes('Macintosh')) {
        return 'mac';
    }
    return 'unknown';
};

var usePlatform = function (initial) {
    if (initial === void 0) { initial = 'unknown'; }
    var _a = useState(initial), platform = _a[0], setPlatform = _a[1];
    useEffect(function () {
        setPlatform(getPlatform());
    }, []);
    return platform;
};

export { getPlatform, usePlatform };
//# sourceMappingURL=index.es.js.map
